import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { createStore as createReduxStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import axios from "axios"
import { logger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import reducers from "./redux/reducers";
import sagas from "./redux/sagas"
const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware];
if (process.env.NODE_ENV === "development") {
  middlewares.push(logger)
}
const reduxStore = createReduxStore(reducers, compose(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);

axios.defaults.baseURL = process.env.REACT_APP_CLOUD_FUNCTONS_URL

ReactDOM.render(
  <Provider store={reduxStore}>
    <App />
  </Provider>,
  document.getElementById('root')
);
